import { render, staticRenderFns } from "./SettingsExchangeRatesCurrencies.vue?vue&type=template&id=1ce51e0c&"
import script from "./SettingsExchangeRatesCurrencies.vue?vue&type=script&lang=js&"
export * from "./SettingsExchangeRatesCurrencies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports